export default __webpack_public_path__ + "static/media/image-visa.ffae47fd.svg";